module.exports = __webpack_public_path__ + "static/media/district.7207dd55.svg";